import {ordersDataActions} from "../../../../slices/orders/orders-data-slice";
import {AppThunk} from "../../../../app/store";
import {apiActions} from "../../../../slices/api-slice";
import {ResponseBase} from "../../../response-base";
import {ApiBaseBack} from "../../api-base-back";
import {
  OptionFoilStampingsRequest,
  OptionFoilStampingsResponse,
} from '../../../../models/api/back/create-order/option-foil-stampings';

export class ApiOptionFoilStampings extends ApiBaseBack<OptionFoilStampingsResponse> {
  constructor(param: OptionFoilStampingsRequest) {
    super(
      'GET',
      '/api/v1/optionLeafColors',
      'JSON',
      param,
    );
  }
}

// export const apiOptionFoilStampingsThunk = (param: OptionFoilStampingsRequest, callback?: () => void, isInit?: boolean): AppThunk => async (dispatch, getState) => {
//   if (!param.productNameId) {
//     dispatch(ordersDataActions.updateOption({
//       optionFoilStamping: [],
//     }));
//     callback?.();
//     return;
//   }
//   dispatch(apiActions.run(
//     new ApiOptionFoilStampings({
//       productNameId: param.productNameId,
//     }),
//     {
//       onSuccess: (res: ResponseBase<OptionFoilStampingsResponse>) => {
//         callback?.();
//         dispatch(ordersDataActions.updateOption({
//           optionFoilStamping: { leafColor: res.body.data?.leafColor || [] },
//         }));
//       },
//       onError: () => {
//         dispatch(ordersDataActions.updateOption({
//           optionFoilStamping: { leafColor: [] },
//         }));
//         callback?.();
//       },
//     },
//     {
//       apiName: 'option-foil-stamping',
//       ignoreSystemError: true,
//     },
//   ))
// };
